import { buildQuery } from '../../utils/buildQuery'
import s from '../../utils/helpers/sanitizations'
// import gql from 'graphql-tag'
import {
  REQUEST,
  SUCCESS,
  ERROR,
  NEXT_PAGE,
  PREV_PAGE,
  RSET_PAGE,
  ROOT,
} from './types'

const state = {
  data: {
    docs: [],
    page: 1,
    limit: 15,
    total: 0,
  },
  loading: false,
  error: false,
  brand: [],
  colors: [],
}

const getters = {
  isLoading: (state) => state.loading,
  isError: (state) => state.error,
  vehiclesList: (state) => state.data,
  brands: (state) => state.brand,
  colors: (state) => state.colors,
}

const actions = {
  async get({ commit, dispatch }, options) {
    commit(REQUEST)
    const query = {
      page: state.data.page || 1,
      per_page: state.data.limit || 15,
      ...options
    }

    query.initial_date = s.dateQueryPattern(query.initial_date)
    query.final_date = s.dateQueryPattern(query.final_date)
    query.search = query.search.replace(/[.-]/g, "$&?")

    const { data } = await dispatch(
      `api`,
      {
        entity: `vehicles`,
        action: `get`,
        query: buildQuery(query)
      },
      { root: true }
    )

    if (data) {
      commit(SUCCESS, data)
    } else {
      commit(ERROR)
    }
  },
  async handleTrucker(context, payload) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `share`,
          action: `post`,
          payload,
        },
        ROOT
      )

      if (response.status !== 204) throw response

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message: `Solicitação de integração realizada com sucesso!`,
          color: `error`,
        },
        ROOT
      )

      context.commit(SUCCESS, null)
    } catch (error) {
      const message =
        error.data?.error ||
        error.data?.errors ||
        `Ocorreu um erro ao integrar o veículo com o trucker, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      context.commit(ERROR)
    }
  },
  async getVehicleBrand(context) {
    try {
      if (context.getters.brands.length) return context.getters.brands
      const response = await context.dispatch(`api`, { entity: `brand`, action: `get`, }, ROOT)
      context.commit(`SET_BRANDS`, response.data)
      // const response = await context.dispatch(`graphql`,
      //   gql`
      //     query {
      //       brands: getAllBrands {
      //         name
      //         _id
      //       }
      //     }
      //   `,
      //   ROOT
      // )
      // if (!response?.data?.brands) throw new Error("Invalid query/response")
      // context.commit(`SET_BRANDS`, response.data.brands.map(brand => ({
      //   ...brand,
      //   _id: brand._id.length === 26 ? brand._id.substr(2).toLowerCase() : brand._id
      // })))
      return response.data
    } catch (err) {
      this.snackMessage = `Houve um erro ao carregar a página. Tente novamente mais tarde.`
      this.hasError = true
      console.log(err)
      return []
    }
  },
  async getColors(context) {
    try {
      if (context.getters.colors.length) return context.getters.colors
      const response = await context.dispatch(`api`, { entity: `colors`, action: `get`, }, ROOT)
      context.commit(`SET_COLORS`, response.data)
      return response.data
    } catch (err) {
      this.snackMessage = `Houve um erro ao carregar as cores. Tente novamente mais tarde.`
      this.hasError = true
      console.log(err)
      return []
    }
  },
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, payload) {
    if (payload) {
      state.data = payload
    }
    state.loading = false
    state.error = false
  },
  [ERROR](state) {
    state.error = true
    state.loading = false
  },
  [NEXT_PAGE](state) {
    state.data.page += 1
  },
  [PREV_PAGE](state) {
    state.data.page -= 1
  },
  [RSET_PAGE](state, page = 1) {
    state.data.page = page
  },
  SET_BRANDS(state, brands) {
    state.brand = brands
  },
  SET_COLORS(state, colors) {
    state.colors = colors
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
